import cn from 'classnames'
import { LogoWordmark } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import ProBold from '../assets/pro-bold.svg'
import ProMedium from '../assets/pro-medium.svg'
import { EXPERIMENT_I18N_NAMESPACE } from '../i18n'
import classes from './ProLockup.module.scss'

export const ProLockup = ({
  weight = 'bold',
  className,
}: {
  weight?: 'bold' | 'medium'
  className?: string
}) => {
  const { t } = useTranslation(EXPERIMENT_I18N_NAMESPACE)
  const Pro = weight === 'medium' ? ProMedium : ProBold

  return (
    <span
      role='img'
      aria-label={t('pro.name')}
      className={cn(classes.lockup, className)}
    >
      <LogoWordmark aria-hidden className={classes.wordmark} />
      <Pro aria-hidden className={classes.pro} />
    </span>
  )
}
